import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Axios from 'axios'
import { LocationOnOutlined, HomeOutlined, CloudOutlined } from "@material-ui/icons"

import './rightbar.css'
import EmptyStateFriends from '../emptyStateFriends/EmptyStateFriends'
import SkeletonAbout from '../skeletonAbout/SkeletonAbout'
import SkeletonFriends from '../skeletonFriends/SkeletonFriends'
import SkeletonFriendsHome from '../skeletonFriendsHome/SkeletonFriendsHome'

const Rightbar = ({ user, userFetching, localisation }) => {
    const PF = process.env.REACT_APP_PUBLIC_FOLDER
    const API = process.env.REACT_APP_API_URL

    //Initializing states
    const [friends, setFriends] = useState([])
    const [isFetching, setIsFetching] = useState(false)

    useEffect(() => {
        const fetchFriends = async () => {
            try {
                setIsFetching(true)
                const res = await Axios.get(API + `users/friends/${user._id}`)
                setFriends(res.data.friends)
                setIsFetching(false)
            } catch (error) {
                console.log(error)
            }
        }
        if(user._id)
            fetchFriends()
    }, [user._id])

    const HomeRightBar = () => {
        return (
            <div className='rightbar homeRightBar'>
                <div style={{ paddingLeft: '1rem' }}>
                    <div className="rightbarWrapper">
                    <h3 className="rightbarTitle">Friends</h3>
                    {
                        isFetching 
                        ?
                        <SkeletonFriendsHome />
                        :
                        <ul className="rightbarFriendsList">
                        {
                            friends.length === 0
                            ?
                            <EmptyStateFriends />
                            :
                            friends.map((friend) => (
                                <li key={friend._id} className="rightbarFriend">
                                    <div className="rightbarProfileImgContainer">
                                        <img src={friend.profilePicture || (PF + "person/default_avatar.jpg")} alt="" className="rightbarProfileImg" />
                                        <span className="rightbarOnline"></span>
                                    </div>
                                    <span className="rightbarUsername">{friend.username}</span>
                                </li>
                            ))
                        } 
                        </ul>
                    }
                    </div>
                </div>
            </div>
        )
    }

    const ProfileRightBar = () => {
        return (
            <div className="rightbar profileRightbar">
                <div className="rightbarWrapper">
                    <div className="infoContainer">
                        <h4 className="rightbarTitle">About</h4>
                        {
                            userFetching
                            ?
                            <SkeletonAbout />
                            :
                            <div className="rightbarInfo">
                            <div className="rightbarInfoItem">
                                <span className="infoIcon">
                                    <LocationOnOutlined />
                                </span>
                                <div>
                                <span className="rightbarInfoKey">From: </span>
                                <span className="rightbarInfoValue">{(user.from_city && user.from_country) ? `${user.from_city}, ${user.from_country}` : "Not mentioned"}</span>
                                </div>
                            </div>
                            <div className="rightbarInfoItem">
                                <span className="infoIcon">
                                    <HomeOutlined />
                                </span>
                                <div>
                                <span className="rightbarInfoKey">Living in: </span>
                                <span className="rightbarInfoValue">{(user.living_in_city && user.living_in_country) ? `${user.living_in_city}, ${user.living_in_country}` : "Not mentioned"}</span>
                                </div>
                            </div>
                            <div className="rightbarInfoItem">
                                <span className="infoIcon">
                                    <CloudOutlined />
                                </span>
                                <div>
                                    <span className="rightbarInfoKey">Favorite Season: </span>
                                    <span className="rightbarInfoValue">{user.fav_season || "Not mentioned"}</span>
                                </div>
                            </div>
                            </div>
                        }
                    </div>
                    <div className="friendsContainer">
                        <h4 className="rightbarTitle">Friends</h4>
                        {
                            isFetching
                            ?
                            <SkeletonFriends />
                            :
                            
                            ( 
                                friends.length !== 0
                                ?
                                <div className="rightbarFollowings">
                                    {
                                        friends.map((friend) => (
                                            <Link to={`/profile/${friend.username}`} style={{ textDecoration: 'none' }} key={friend._id}>
                                                <div className="rightbarFollowing">
                                                    <img src={friend.profilePicture || PF + "person/default_avatar.jpg"} alt="" className="rightbarFollowingImg" />
                                                    <span className="rightbarFollowingName" style={{ color: '#333' }}>{friend.username}</span>
                                                </div>
                                            </Link>
                                        ))
                                    }
                                </div>
                                :
                                <EmptyStateFriends />
                            )
                        }
                    </div>
                </div>
            </div>
        )
    }

    return (
        localisation === "profile" ? <ProfileRightBar /> : <HomeRightBar />
    )
}

export default Rightbar
